export const guideEventPayload = (location, name, url) => ({
    'Guide location': location,
    'Guide name': name,
    'Guide URL': url,
});

export const seeMoreEventPayload = (url) => ({
    'Link URL': url,
});
